import { getAuthToken, getLoggedInUser } from './auth';
import { talktreesOnboardedUrl } from '../apiConfig';

const REAL_TREE_CREATED_PREFIX = 'tt_real_tree_created';

function storageKeyForUser(username) {
  const user = (username || getLoggedInUser() || '').toLowerCase().trim();
  return user ? `${REAL_TREE_CREATED_PREFIX}:${user}` : null;
}

async function markOnboarded() {
  const token = getAuthToken();

  const res = await fetch(talktreesOnboardedUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (!res.ok) {
    let detail = '';
    try {
      const body = await res.json();
      detail = body?.error || '';
    } catch {
    }
    throw new Error(detail || `Failed to mark onboarded (status ${res.status})`);
  }

  return res.json().catch(() => ({}));
}

export function hasCreatedRealTree(username) {
  try {
    const key = storageKeyForUser(username);
    if (!key) return false;
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

export function markRealTreeCreated(username) {
  try {
    const key = storageKeyForUser(username);
    if (!key) return;
    if (localStorage.getItem(key) === 'true') return;
    localStorage.setItem(key, 'true');
  } catch (err) {
    console.error('Failed to persist real tree creation status:', err);
  }

  markOnboarded().catch((err) => {
    console.error('Failed to sync onboarded status to server:', err);
  });
}